<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h2>Digital Eco System</h2>
      </v-col>
      <v-col cols="12">
        <v-btn
          :to="`/users/project/${$route.params.id}/eco-system/create`"
          light
          color="amber"
          class="mt-5 mb-5"
          >Add option</v-btn
        ></v-col
      >
      <v-col cols="4" v-for="item in orderedItems" :key="item.id">
        <v-card light height="100%">
          <v-card-title>
            <h3 class="title" v-if="item.doc.title">{{ item.doc.title }}</h3>
            <h3 class="title" v-else>{{ item.id }}</h3>
          </v-card-title>

          <v-card-actions>
            <v-btn light color="amber" class="mb-2" @click="editCard(item.id)"
              >View</v-btn
            >
            <v-btn light color="amber" class="mb-2" @click="cloneCard(item.doc)"
              >Clone</v-btn
            >
            <v-btn
              light
              color="amber"
              class="mb-2"
              @click="deleteRequest(item.id)"
              >Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <bottom-navigation
      :save="false"
      :next="false"
      :prev="false"
      :list="`eco-system`"
      :gridView="false"
      :gridToggle="false"
    >
    </bottom-navigation>

    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to delete this?</v-card-title
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="deleteItem">
            Delete
          </v-btn>
          <v-btn color="amber" text @click="closeDialog">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import router from "@/router";

export default {
  name: "UserEcoSystemMenu",
  data() {
    return {
      items: [],
      cardId: null,
      dialog: false,
      collection: fb.ecoExCollection,
      returnRoute: "UserEcoSystemMenu",
    };
  },
  components: {
    BottomNavigation,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    orderedItems() {
      return this.items ? lodash.orderBy(this.items, "doc.title", "asc") : [];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.collection
        .where("pid", "==", this.$route.params.id)
        .onSnapshot((querySnapshot) => {
          let items = [];
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          this.items = items;
        });
    },
    closeDialog() {
      this.cardId = null;
      this.dialog = false;
    },
    deleteRequest(id) {
      this.cardId = id;
      this.dialog = true;
    },
    deleteItem() {
      this.collection
        .doc(this.cardId)
        .delete()
        .then(() => {
          this.dialog = false;
          this.cardId = null;
          router.push({
            name: this.returnRoute,
          });
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });
    },
    editCard(id) {
      this.$router.push(
        `/users/project/${this.$route.params.id}/eco-system/${id}`
      );
    },
    cloneCard(doc) {
      let ref;
      const clonedDoc = {
        ...doc,
      };
      clonedDoc.title = `${doc.title} (copy)`;
      ref = this.collection.doc();
      ref
        .set({
          updatedOn: new Date(),
          id: ref.id,
          uid: this.currentUser.uid,
          pid: this.currentProjectModel.id,
          doc: clonedDoc,
        })
        .then(() => {
          console.log("saved item");
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
  },
};
</script>

<style lang="scss"></style>
